import { useEffect, useState } from "react";

const HIGH = { tier: "high", loops: true, mobile: false, reduced: false };

/**
 * Bản rút gọn của phép dò khả năng thiết bị ở bản gốc: người bật giảm chuyển
 * động nhận tier "low", màn hẹp nhận "mid" (bỏ blend mode, ít bóng đèn hơn),
 * còn lại nhận trọn màn diễn. Chốt sau khi mount để render đầu tiên khớp nhau.
 */
export function useMotionBudget() {
    const [budget, setBudget] = useState(HIGH);

    useEffect(() => {
        const reducedQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        const narrowQuery = window.matchMedia("(max-width: 767px)");

        const resolve = () => {
            const reduced = reducedQuery.matches;
            const narrow = narrowQuery.matches;
            setBudget({
                tier: reduced ? "low" : narrow ? "mid" : "high",
                loops: !reduced,
                mobile: reduced || narrow,
                reduced
            });
        };

        resolve();
        reducedQuery.addEventListener("change", resolve);
        narrowQuery.addEventListener("change", resolve);
        return () => {
            reducedQuery.removeEventListener("change", resolve);
            narrowQuery.removeEventListener("change", resolve);
        };
    }, []);

    return budget;
}
